/**
 * 知识库相关类型定义
 */

/**
 * 知识库文档类型枚举
 */
export enum KnowledgeDocType {
  /** 文本类型 */
  TEXT = 1,
  /** 表格类型 */
  TABLE = 2,
}

/**
 * 知识库状态枚举
 */
export enum KnowledgeStatus {
  /** 禁用 */
  DISABLED = 0,
  /** 启用 */
  ENABLED = 1,
}

/**
 * 知识库基础信息
 */
export interface KnowledgeBase {
  /** 知识库ID */
  id: string
  /** 知识库名称 */
  name: string
  /** 创建人 */
  creator: string
  /** 创建人ID */
  creatorId: string
  /** 文档类型 */
  docType: KnowledgeDocType
  /** 文件数量 */
  filesNum: number
  /** 是否为当前用户创建 */
  isCurrentUser: number
  /** 知识库状态 */
  status: KnowledgeStatus
  /** 工作空间ID */
  workspaceId: string
  /** 创建时间 */
  createTime?: string
}

/**
 * 获取知识库列表请求参数
 */
export interface GetKnowledgeListRequest {
  /** 搜索关键词 */
  search?: string
  /** 工作空间ID */
  workspaceId: string
}

/**
 * 知识库列表响应
 */
export interface KnowledgeListResponse {
  knowledgeBases: KnowledgeBase[]
}

/**
 * 新增/编辑知识库请求参数
 */
export interface SaveOrUpdateKnowledgeRequest {
  /** 知识库ID（编辑时必填） */
  id?: string
  /** 知识库名称 */
  name: string
  /** 知识库类型 */
  docType?: KnowledgeDocType
  /** 工作空间ID */
  workspaceId: string
}

/**
 * 删除知识库请求参数
 */
export interface DeleteKnowledgeRequest {
  /** 知识库ID */
  id: string
}

/**
 * 切换知识库状态请求参数
 */
export interface ToggleKnowledgeStateRequest {
  /** 知识库ID */
  id: string
  /** 知识库状态 */
  status: KnowledgeStatus
}
